import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Avatar
} from '@mui/material';
import { Edit, Delete, DragIndicator } from '@mui/icons-material';
import DeleteConfirmationModal from '../DeleteConfirmationModal/DeleteConfirmationModal';
import './ContentListItem.css';

const ContentListItem = ({
    title,
    description,
    thumbnailUrl,
    onEdit,
    onDelete,
    isDraggable = false
}) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const handleDeleteClick = () => {
        setIsDeleteModalOpen(true);
    };

    const handleConfirmDelete = () => {
        onDelete();
        setIsDeleteModalOpen(false);
    };

    return (
        <>
            <Card className="content-list-item">
                {isDraggable && (
                    <div className="drag-handle">
                        <DragIndicator />
                    </div>
                )}
                <Box className="content-info">
                    <Avatar 
                        variant="rounded" 
                        className="content-avatar"
                        src={thumbnailUrl}
                        alt={title}
                    />
                    <CardContent className="content-details">
                        <Typography variant="h6" component="h3" className="content-title">
                            {title}
                        </Typography>
                        <Typography variant="body2" className="content-description">
                            {description}
                        </Typography>
                    </CardContent>
                </Box>
                <div className="content-actions">
                    <IconButton onClick={onEdit} size="small" style={{ color: '#fff' }}>
                        <Edit />
                    </IconButton>
                    <IconButton onClick={handleDeleteClick} color="error" size="small">
                        <Delete />
                    </IconButton>
                </div>
            </Card>
            <DeleteConfirmationModal
                open={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                itemName={title}
            />
        </>
    );
};

export default ContentListItem; 